import { Component, ViewChild } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { IsIgxDialogComponent, IsIgxHubComponent, IsIgxMappingComponent } from '@interserve/igx-angular'
import { IgxButtonModule } from '@infragistics/igniteui-angular'
import { Router } from '@angular/router'
import { TestdataService } from '../../services/testdata.service'
import { ShipemntRangeApiServiceApiService } from '../../api/shipment-range-api.service'
import { selectDataHubInfo } from '../test/data'
import { environment } from 'src/environments/environment'
@Component({
    selector: 'is-igx-wbs-sample2',
    standalone: true,
    templateUrl: './sample-testdata-create.html',
    styleUrl: './SampleTestDataCreateComponent.scss',
    imports: [
        CommonModule,
        FormsModule,
        IsIgxMappingComponent,
        IsIgxHubComponent,
        IsIgxDialogComponent,
        IgxButtonModule,
    ],
})
export class SampleTestDataCreateComponent {
    @ViewChild('selectDataHub', { static: false }) public selectDataHub: IsIgxHubComponent | undefined
    constructor(
        private router: Router,
        private testdataService: TestdataService,
        private shipemntRangeApiServiceApiService: ShipemntRangeApiServiceApiService
    ) {
    }
    environmentKey = environment.environmentKey
    fileName: string = ''
    startDate: string = ''
    endDate: string = ''
    dueDate: string = ''
    showMessage = false
    message = ''

    loading = true
    reload = false
    //HUB設定（紐づけで使用）
    selectTestDataHubSettings = structuredClone(selectDataHubInfo)
    staticSelectTestData:any[] = []
    selectTestDataHubActions = {
        select: (event: any) => {
          const selected = event.leftWbs.selected
            if (selected.length === 0) {
                alert('WBSを選択してください。')
            } else {
                //選択したものをループして確認
                this.testdataService.setSelectedData(selected)
                this.router.navigate(['納品日指定'])
                console.log('WBS:', selected)
            }
        },
    }

    createContent() {
        var msg = 'ファイル名:' + this.fileName + '\n' + '期間:' + this.startDate + '~' + this.endDate + '\n'
        const addData = {
            id: crypto.randomUUID(),
            name: this.fileName,
        }

        if (this.fileName === '') {
            alert('ファイル名を入力してください')
            return
        }
        const createFileObj = {
            fileName: this.fileName,
            distributionPlaceCd: 'cb910882d3944ac098de3df9a2f6e4f6',
            deliveryDateFrom: this.startDate,
            deliveryDateTo: this.endDate,
            replaceBaseDate: this.dueDate,
        }

        // ファイル作成API呼び出し
        this.shipemntRangeApiServiceApiService.FileCreate(createFileObj).subscribe((ret) => {
            this.message = msg
            this.showMessage = true
        })
    }

    ngOnInit(): void {
        this.startDate = '2024-03-01'
        this.endDate = '2024-03-03'
        this.dueDate = '2024-03-18'
        this.loading = false
    }

    openTestDataHub() {
        this.shipemntRangeApiServiceApiService.FileList('cb910882d3944ac098de3df9a2f6e4f6').subscribe((ret) => {
            console.log(ret)
            const data = ret.data.map((item: any) => {
                return { id: item.eTag, name: item.key }
            })

            this.staticSelectTestData = data
            this.selectDataHub?.open()
        })
    }
}
